/**
 * @module ScrollUpButton
 * @return {Object} public methods.
 */
var ScrollUpButton = (function () {
    var $doc;
    var $html;
    var $button;

    function init() {
        if ($('#footer__up').length === 0) return false;

        getDOMElements();
        addEventListener();
    }

    function getDOMElements() {
        $doc = $(document);
        $html = $('html');
        $button = $('#footer__up');
    }

    function addEventListener() {
        $button.click(onButtonClick);
        $doc.scroll(onDocumentScroll);
    }

    function onButtonClick() {
        $html.velocity('scroll', {duration: 700, mobileHA: false});
    }

    function onDocumentScroll() {
        if ($doc.scrollTop() >= 60) {
            $button.css({opacity: 1});
        } else {
            $button.css({opacity: 0});
        }
    }

    // Return public methods
    return {
        init: init
    };
})();

window.ScrollUpButton = ScrollUpButton;
export default ScrollUpButton;
